import { useMemo } from 'react'
import { EnpsPage } from './EnpsPage'
import { createEnpsDashboardStore } from './stores/enpsDashboardStore'

/**
 * @fileoverview eNPS Page Container
 *
 * Container component that initializes the dashboard store
 */

export const EnpsPageContainer = () => {
	const store = useMemo(() => createEnpsDashboardStore(), [])

	return <EnpsPage store={store} />
}
